<template>
  <div>
    <datatable
      :show_delete="false"
      title="Companies"
      @thFilter="thFilter"
      @create="createCompany"
      @edit_leave="editLeave"
      @edit_hover="editHover"
      @edit_click="editClick"
      @internal_notes="clickedInternalNotes"
      @positions="goToCompanyPositions"
      @find_new_companies="findNewCompanies"
      @create_position="createCompanyPosition"
      @recommendation="manageRecommendation"
      :fields="fields"
      :unique_buttons="unique_buttons"
      :sorters="sorters"
      :filters="filters"
      :response="data"
      :operations="operations"
      :working_th_searches="working_th_searches"
    ></datatable>
  </div>
</template>
<script>
import { mapGetters, mapMutations } from 'vuex'
import FiltersHelper from '@/custom/classes/filters_helper.js'
import DataTable from '@/components/DataTable.vue'
import PhoneCallButton from '@/components/PhoneCallButton.vue'
export default {
  name: 'admin-companies',
  data () {
    let filters_helper = new FiltersHelper()
    return {
      filters_helper,
      fields: [
        {
          name: 'company_name',
          component_data_path: 'resource.company',
          component: 'LinkEntity'
        },
        {
          name: 'positions',
          value: 'positions'
        },
        {
          name: 'message',
          value: 'message',
          component: 'Message',
          additional_data: {
            endpoint: '/users/',
            headers: 'admin_headers',
            resource_type: 'Company'
          }
        },
        {
          name: 'updated_at',
          value: 'updated_at',
          is_time: true
        },
        {
          name: 'created_at',
          value: 'created_at',
          is_time: true
        },
        {
          name: 'owner',
          value: 'owner'
        },
        {
          name: 'default_cv_sending_mode',
          value: 'resource.company.default_cv_sending_mode'
        },
        {
          name: 'id',
          value: 'id'
        }
      ],
      sorters: [
        {
          designator: 'id',
          value: '-id'
        },
        {
          designator: 'last_login',
          value: '-last_login'
        }
      ],
      filters: [
        {
          type: 'modal',
          designator: 'office_size',
          options: []
        },
        {
          type: 'checkbox',
          designator: 'has_position',
          title: 'Has Position'
        }
      ],
      th_filters: [],
      data: [],
      unique_buttons: [
        { name: 'find_new_companies', display_text: 'find new companies' }
      ],
      operations: [
        {
          component: 'CompletenessIndicator',
          component_data_path: 'resource.company',
          additional_data: { api_path: '/companies/' }
        },
        { name: 'positions' },
        { name: 'recommendation' },
        { name: 'create_position' },
        { component: 'PreviewCompanyInPanel' },
        { name: 'internal_notes', icon: '/note.png' },
        {
          component: 'AlertButton',
          additional_data: { resource_type: 'Company' }
        },
        {
          component: 'PhoneCallButton',
          component_data_path: 'resource_id'
        }
      ],
      working_th_searches: ['company_name', 'owner']
    }
  },
  created: function () {
    this.init()
  },
  computed: {
    ...mapGetters('modals', ['findModal'])
  },
  methods: {
    init () {
      this.getCompanies()
      this.getQuestionsFilters()
    },
    getCompanies () {
      this.$network_utils
        .getAllCompanies({
          page: this.$route.query.page || 1,
          per: 100,
          sort: this.$route.query.sort,
          has_position: this.$route.query.has_position,
          ...this.filters_helper.getServerCallFilters(this.filters),
          ...this.th_filters
        })
        .then(response => {
          response = Array.isArray(response) ? response : [response]
          this.data = response
        })
    },
    getQuestionsFilters () {
      this.$network_utils.getQuestions({ designators: 'office_size', current_resource_id: 1, current_type: 'Applicant' }).then(response => {
        response.forEach(question => {
          this.addQuestionOptionsToFilters(question)
        })
        this.$forceUpdate()
      })
    },
    addQuestionOptionsToFilters (question) {
      let filter_options = question.options.map(option => {
        return { text: option.text, value: option.id.toString() }
      })
      this.filters = this.filters.map(filter => {
        if (filter.designator == question.designator) {
          return { ...filter, options: filter_options }
        }
        return filter
      })
    },
    thFilter (th_filters) {
      this.th_filters = th_filters
      this.getCompanies()
    },
    goToCompanyPositions (data) {
      let link = this.$router.resolve({ name: 'company-positions', query: { company_id: data.resource_id, sort: '-is_hot' } })
      this.$utils.openInNewTab(link.href, '_self')
    },
    createCompanyPosition (data) {
      this.create({
        designator: 'create-position-step-one',
        component_name: 'CreatePositionStepOne',
        ignore_escape_button: true,
        company_id: data.resource_id,
        modal_title: 'Create Position'
      })
    },
    findNewCompanies () {
      this.create({
        designator: 'alert-form-modal',
        component_name: 'AlertForm',
        is_create: true,
        init_designator: 'find_new_companies',
        initContent: 'איתור חברות חדשות',
        modal_title: 'Create new Alert'
      })
    },
    createCompany () {
      this.create({
        designator: 'create-company-step-one',
        component_name: 'CreateCompanyStepOne',
        ignore_escape_button: true,
        modal_title: 'Create new Company'
      })
    },
    manageRecommendation (data) {
      this.create({
        designator: 'service-recommendation-modal',
        component_name: 'ServiceRecommendation',
        resource_type: 'Company',
        resource_id: data.resource_id,
        is_multiple: true,
        modal_title: data.resource.company.name + ' המלצה של'
      })
    },
    editClick (data) {
      this.create({ designator: 'company-form-modal', component_name: 'CompanyForm', data, modal_title: data.resource.company.name })
    },
    editHover (data) {
      this.create({ designator: 'company-info-modal', component_name: 'CompanyInfo', data: data.resource.company, modal_title: 'Company: ' + data.resource.company.name })
    },
    editLeave () {
      let company_info_modal = this.findModal({ type: 'designator', value: 'company-info-modal' })
      this.remove(company_info_modal)
    },
    clickedInternalNotes (data) {
      this.create({ designator: 'internal-notes-modal', component_name: 'InternalNotes', resource_type: 'Company', resource_id: data.resource_id, modal_title: data.resource.company.name + ' הערות פנימיות' })
    },
    ...mapMutations('modals', ['remove', 'create'])
  },
  components: {
    datatable: DataTable,
    PhoneCallButton // eslint-disable-line vue/no-unused-components
  }
}
</script>
<style scoped></style>
